export default "__VITE_ASSET__tNeS8bBQ__"